import Url from 'url-parse';
import './product-prop-65';
/**
 * NOTE: You must include this file into a layout or template that uses the product-info-area snippet.
 * It doesn't automatically get included where the snippet is.
 */

$(function () {
  console.debug('Begin Product Info Area initialization...');

  function maybeInjectYotpoReviewsContent($container, $wrapper) {
    if ($container.hasClass('yotpo-product-reviews') && $('.yotpo-main-widget', $container).length === 0) {
      $container.append($('.yotpo-main-widget', $wrapper));
    }
  } // desktop


  $('.product-info').each(function (_, productInfoEle) {
    var $wrapper = $(productInfoEle).closest('.product-info-wrapper');
    var $active;
    var $content;
    var $links = $('ul.tabs', productInfoEle).find('a');
    console.debug('Init Product Info Area', $wrapper, $links);
    $active = $links.first().addClass('active');
    $content = $($active.attr('href'));
    $links.not(':first').each(function (idx, ele) {
      return $($(ele).attr('href')).hide();
    });
    $links.click(function (evt) {
      evt.preventDefault();
      $active.removeClass('active');
      $content.hide();
      $active = $(evt.target);
      $content = $($(evt.target).attr('href'));
      console.debug('Product area link click', evt, $active, $content);
      maybeInjectYotpoReviewsContent($content, $wrapper);
      $active.addClass('active');
      $content.show();
      return false;
    });
  }); // Mobile

  $('.product-info-mobile .accordion').each(function (_, accordianElement) {
    var $wrapper = $(accordianElement).closest('.product-info-wrapper');
    $(accordianElement).click(function (evt) {
      var $button = $(evt.target);
      $button.toggleClass('active');
      var $panel = $button.next('.panel');
      maybeInjectYotpoReviewsContent($panel, $wrapper);
      $panel.toggle();
      $panel.focus();
    });
  }); // set reviews link depending on mobile or desktop

  var $featuredReviewDiv = $('#featured-review-div');
  var $featuredReviewLink = $('#featured-review-link');

  if ($('#reviews-mobile:visible').length === 1) {
    $featuredReviewDiv.addClass('reviews-skip-link--mobile');
    $featuredReviewLink.attr('href', '#reviews-mobile');
  } else {
    $featuredReviewDiv.addClass('reviews-skip-link');
    $featuredReviewLink.attr('href', '#reviews');
  } // setup review skip links to click on the reviews tab at the bottom of the page (i.e. navigate to reviews)


  $('.reviews-skip-link, .reviews-skip-link span, .reviews-skip-link--mobile, .reviews-skip-link--mobile span, .yotpo .star-clickable, .yotpo-stars, .yotpo .star-clickable a').click(function (evt) {
    if (evt.target.classList.contains('reviews-skip-link--mobile') || $(evt.target).parents('.reviews-skip-link--mobile').length > 0) {
      var $accordionButton = $('#reviews-mobile');

      if ($accordionButton.hasClass('active')) {
        var url = new Url(window.location.href);
        window.location.href = url.set('hash', 'reviews-mobile').toString();
      } else {
        $accordionButton.click();
      }
    } else {
      $('#reviews').click();
    }
  });
});